import styled from 'styled-components';
import { edgeStyle } from 'grommet/es6/utils';


var ROUND_MAP = {
  'full': '100%'
};

export var StyledImageStamp = styled.img.withConfig({
  displayName: 'StyledImageStamp',
  componentId: 'sc-14qw7ay-0'
})(['', ' ', ' overflow:hidden;object-fit:cover;border-radius:', ';-webkit-border-radius:', ';-moz-border-radius:', ';'], function (props) {
  return (!props.contain || props.contain === 'width') && props.size && edgeStyle('width', props.size, props.responsive, undefined, props.theme);
}, function (props) {
  return (!props.contain || props.contain === 'height') && props.size && edgeStyle('height', props.size, props.responsive, undefined, props.theme);
}, function (props) {
  return ROUND_MAP[props.round] || props.theme.global.edgeSize[props.round];
}, function (props) {
  return ROUND_MAP[props.round] || props.theme.global.edgeSize[props.round];
}, function (props) {
  return ROUND_MAP[props.round] || props.theme.global.edgeSize[props.round];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/ImageStamp/StyledImageStamp.js
// module id = 1160
// module chunks = 0